import { render } from "./JobUI.vue?vue&type=template&id=f19a387e"
import script from "./JobUI.vue?vue&type=script&lang=js"
export * from "./JobUI.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__